export const MEDIAPLAYER_DEFAULT_VOLUME = 1.0;
export const MEDIAPLAYER_DEFAULT_SPEED = 1.0;

export interface UserSettings {
  mediaPlayer: {
    volume: number;
    playbackSpeed: number;
    position?: { x: number; y: number };
  };
}

export const DEFAULT_USER_SETTINGS: UserSettings = {
  mediaPlayer: {
    volume: MEDIAPLAYER_DEFAULT_VOLUME, // Explicitly number
    playbackSpeed: MEDIAPLAYER_DEFAULT_SPEED, // Explicitly number
    position: { x: 0, y: 0 },
  },
};
